const state = {
  loginVisible: false
}

const mutations = {
  SET_LOGIN_VISIBLE: (state, val) => {
    state.loginVisible = val
  }
}

const actions = {
  setVisible({ commit }, bool) {
    commit('SET_LOGIN_VISIBLE', bool)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js